import { Injectable, Inject, ErrorHandler } from "@angular/core";
import * as Raven from "raven-js";
import { IonicErrorHandler } from "ionic-angular";
import {
  ENV_VARS,
  EnvironmentVariables
} from "../environment-variables/environment-variables.module";

@Injectable()
export class CustomErrorHandler extends IonicErrorHandler
  implements ErrorHandler {
  constructor(@Inject(ENV_VARS) private envVars: EnvironmentVariables) {
    super();
  }
  handleError(err: any): void {
    super.handleError(err);
    if (this.envVars.ENABLE_SENTRY === "YES") {
      Raven.captureException(err);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/services/errorhandler.ts